import { useMemo, useState } from 'react';
import { embodiedCarbon } from '../../../engine/embodiedCarbon';
import { useAIContext } from '../store/aiContextStore';

export function ConstructionMode() {
  const [concrete, setConcrete] = useState(10000);
  const [steel, setSteel] = useState(2000);
  const [ins, setIns] = useState<'mineral'|'foam'|'cellulose'>('mineral');
  const res = useMemo(()=> embodiedCarbon({ concreteKg: concrete, steelKg: steel, insulation: ins }), [concrete, steel, ins]);
  return (
    <div className="space-y-2 border border-evat-gold/40 rounded p-3">
      <div className="font-orbitron text-evat-gold">Embodied Carbon (Construction)</div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-2 text-sm">
        <label className="flex items-center gap-2">Concrete kg<input type="number" value={concrete} onChange={(e)=>{
          setConcrete(Number(e.target.value));
          useAIContext.getState().setInput('concreteKg', e.target.value);
        }} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-32"/></label>
        <label className="flex items-center gap-2">Steel kg<input type="number" value={steel} onChange={(e)=>{
          setSteel(Number(e.target.value));
          useAIContext.getState().setInput('steelKg', e.target.value);
        }} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-32"/></label>
        <label className="flex items-center gap-2">Insulation
          <select value={ins} onChange={(e)=>{
            setIns(e.target.value as any);
            useAIContext.getState().setInput('insulation', e.target.value);
          }} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1">
            <option value="mineral">mineral</option>
            <option value="foam">foam</option>
            <option value="cellulose">cellulose</option>
          </select>
        </label>
      </div>
      <div className="text-neutral-300">Total: <span className="text-evat-neon">{res.totalKg} kg CO2e</span></div>
      <div className="text-xs text-neutral-500">Breakdown: concrete {res.breakdown.concrete}, steel {res.breakdown.steel}, insulation {res.breakdown.insulation}</div>
    </div>
  );
}

export default ConstructionMode;





